import { startGateway } from './gateway/gateway';
import { onException } from './exception-handler';

startGateway().catch(function (error) {
  onException(error, 'bootstrap');
});
